export default {
    "addresses": "3a0e9d7fc16f3582a37ec3f6b3ca232c4304ae4951feeb652684aaffdcb12fd8",
    "createCustomerAddress": "3c235ab4adcea9f75eadb46dae48fb995ffa9a936e9e872985a2f7f3c476cf82",
    "updateCustomerAddress": "7a0c806aa95226bbd8b19f4c95fef08f1793b44bfb7a324883594721d79e11f1",
    "deleteCustomerAddress": "4949f40418fb31fa3db56fac0548e7482d04fd6a2d24e41742d68e81ae4d5003"
};
